import AppConstants from '@/common/constants/app.constants';
import AuthService from '@/common/service/auth.service';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { LoginRequest } from '@/common/model/request/login-request.model';
import { UserResponse } from '@/common/model/response/user-response.model';

const storedToken = localStorage.getItem(AppConstants.STORAGE_TOKEN);

@Module({ namespaced: true })
export default class Auth extends VuexModule {
  private authService = new AuthService();
  public status = storedToken ? { loggedIn: true } : { loggedIn: false };
  _userDetailsStorage: string | null = localStorage.getItem(AppConstants.STORAGE_USER_DETAILS);
  _userDetails: UserResponse = this._userDetailsStorage
    ? JSON.parse(this._userDetailsStorage)
    : {
        avatar: '',
        userName: '',
        email: '',
        nickName: '',
        userId: 0
      };

  @Mutation
  public loginSuccess(_user: LoginRequest): void {
    this.status.loggedIn = true;
    // this.user = user;
  }

  @Mutation
  public setUserDetail(_user: UserResponse): void {
    this._userDetails = _user;
  }

  @Mutation
  public loginFailure(): void {
    this.status.loggedIn = false;
    // this.user = null;
  }

  @Action({ rawError: true })
  public logout(): void {
    this.status.loggedIn = false;
    // this.user = null;
    this.authService.logout();
  }

  @Action({ rawError: true })
  async login(loginRequest: LoginRequest): Promise<string | boolean> {
    const loginErrorMsg = await this.authService.login(loginRequest).catch((error) => {
      this.context.commit('loginFailure');
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return Promise.reject(message);
    });

    if (loginErrorMsg) {
      this.context.commit('loginFailure');
      return Promise.reject(loginErrorMsg);
    }

    const dataResponse = await this.authService.fetchUserDetails();
    this.context.commit('loginSuccess', true);
    this.context.commit('setUserDetail', dataResponse);
    return Promise.resolve(true);
  }

  get isLoggedIn(): boolean {
    return this.status.loggedIn;
  }

  get userDetailNickName(): string | undefined {
    return this._userDetails.nickName;
  }

  get userDetailAvatar(): string | undefined {
    return this._userDetails.avatar;
  }

  get userId(): number | undefined {
    return this._userDetails.userId;
  }
}
